import React, { Fragment } from "react";
import { VACATION_REQUEST_STATUS_ID } from "../../configs/constants";
import DisplayAttachments from "../../modules/presence/components/DisplayAttachments.modal";

const QuickLookModalContent = ({ eventInfos = {}, attachments = [], displayOnlyAttachments }) => {
  return (
    <div>
      {!displayOnlyAttachments && (
        <Fragment>
          <div className="my-4">
            <span className="font-bold">Demande de type : </span>
            <span className="">{eventInfos.title || "N/C"}</span>
          </div>
          <div className="mt-6">
            <span className="font-bold">Validation Manager : </span>

            <span
              className={`font-bold ${
                eventInfos.type === VACATION_REQUEST_STATUS_ID.REJECTED ? "text-red-500" : "text-green-400"
              }`}
            >
              {eventInfos.visitType || "N/C"}
            </span>
          </div>
        </Fragment>
      )}
      <DisplayAttachments attachments={attachments} />
    </div>
  );
};

export default QuickLookModalContent;



// WEBPACK FOOTER //
// src/components/presence/QuickLookModalContent.js